import { useEffect, useRef } from 'react';
import { axios } from 'lib/axios';

export const useTrackVisit = (entityType, entityId, source) => {
  const trackedRef = useRef(null);

  useEffect(() => {
    const key = `${entityType}-${entityId}`;
    if (!entityId || trackedRef.current === key) return;

    trackedRef.current = key;
    axios.post('/api/public/visits', { entity_type: entityType, entity_id: entityId, source }).catch(() => {});
  }, [entityType, entityId, source]);
};
